import { Children, useState } from "react";
import { createContext } from "react";

export const amitContext= createContext("home")

// context boilerplate code daalo 


const ContextProvider = ({ children }) => {
    const [current, setCurrent] = useState('');
    return <amitContext.Provider value={{current, setCurrent}}>
        {
            children
        }
    </amitContext.Provider>
}


export default ContextProvider;